<template>
	<div id="hotlist">
		<div class="hotlist-banner"></div>
		<div class="container  index-con">
					<div class="index-con-tit">
						<div class="index-con-wd hot">
							<h2>娱情一线</h2>
							<h4>Entertainment Spot</h4>
						</div>
						<div class="clearfix"></div>
					</div>
					<ul>
						<li class="hotlist-sty" v-for="item in list" :key="item.id">
							<router-link :to="'/hotcontent/'+item.id">
							<img class="float-left" width="100%" height="auto" v-bind:src="item.picture" v-bind:alt="item.name" />
							<div style=" height: 220px;float: left;position: relative">
								<div class="hotlist-sty-wd">
									<h2>{{item.title}}</h2>
									<p class="hotlist-time">{{item.create_time}}</p>
									<p v-html="item.intro"></p>
									<div class="clearfix"></div>
								</div>
								<a href="" class="hotlist-more">了解更多</a>
							</div>
							</router-link>
							<div class="clearfix"></div>
						</li>
					</ul>

					<v-page :total-row="totalRow" align="center" :page-size-menu="false" :info="false" @page-change="pageChange"></v-page>
					<div class="clearfix"></div>
				</div>
	</div>

</template>
<script>
	import pageNation from './pageNation'

	export default {
		data() {
			return {
				list: [],
				info: {},
				totalRow: 100,
				pageArr: [],
				pageNum: 1,
        		seoList:{
					column_title:'娱乐现场'
				}
			}
		},
    metaInfo() {
      return {
        title: this.seoList.column_title + '-打造影视行业优秀的资源聚合服务平台' || '',
        meta: [{
          name: 'keywords',
          content: this.seoList.column_keywords || ''
        },
          {
            name: 'description',
            content: this.seoList.column_description || ''
          }]
      }
    },
		methods: {
      getSeo(){
        let seoApi = 'http://api.yopoo.cn/api/v1/visit?page=1&count=12&column=2'
        this.$http.get(seoApi)
          .then((res)=>{

            this.seoList = res.body.metas
            this.column_title = this.seoList.column_title
            this.column_keywords = this.seoList.column_keywords
            this.column_description = this.seoList.column_description
          },err =>{
            console.log(err)
          })
      },

			pageChange(pInfo) {
				pInfo.pageSize = 10 //显示count数量
				this.pageNum = pInfo.pageNumber //页码
				this.info = pInfo
				this.$http.get('http://api.yopoo.cn/api/v1/visit?page=' + this.pageNum +
					'&count=' + this.info.pageSize +'&column=2').then((res) => {
                    window.scrollTo(0,0)

                    this.list = res.body.data
					this.pageArr = res.body.pagination //返回分页数组
					this.totalRow = res.body.pagination.total
				}, (err) => {
					console.log(err)
				})

			},
		},
		components:{
			pageNation,
		},
    beforeMount(){
		  this.getSeo()

    }

	}
</script>
<style>
	.hotlist-banner{
		background: url(http://yopoo.oss-cn-beijing.aliyuncs.com/bg-hot.jpg) no-repeat;
		background-size: 100% 100%;
		height: 430px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Hot.vue